/**
 * Notas V1 em modo demo: localStorage JSON (mesma ideia que ocorrências).
 */

import { DEMO_TURMA_DISC } from "./buildDemoOccurrences";

const STORAGE_KEY = "waybee-class-diary-demo-grades-v1";

export function demoGradesSessionKey(idTurmaDisc, idStep, idExam) {
  return `${String(idTurmaDisc)}|${String(idStep)}|${String(idExam)}`;
}

function readRoot() {
  if (typeof localStorage === "undefined") {
    return {};
  }
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw);
    return typeof parsed === "object" && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
}

function writeRoot(root) {
  if (typeof localStorage === "undefined") {
    return;
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(root));
  } catch {
    // ignore
  }
}

export function loadDemoGradesSession(sessionKey) {
  const root = readRoot();
  const entry = root[sessionKey];
  if (!entry || typeof entry !== "object") {
    return null;
  }
  return entry;
}

/**
 * POST ClassDiaryV1/grades — body com grades ou conceptGrades.
 */
export function applyDemoGradesSave(body) {
  if (!body || String(body.idTurmaDisc) !== String(DEMO_TURMA_DISC)) {
    return;
  }

  const sessionKey = demoGradesSessionKey(
    body.idTurmaDisc,
    body.idStep,
    body.idExam
  );

  const existing = loadDemoGradesSession(sessionKey);
  const byRa = {};
  if (existing && existing.byRa) {
    Object.keys(existing.byRa).forEach(ra => {
      byRa[String(ra)] = { ...existing.byRa[ra] };
    });
  }

  const rows = body.conceptGrades || body.grades;
  if (!Array.isArray(rows)) {
    return;
  }

  rows.forEach(row => {
    const ra = row.studentId == null ? null : String(row.studentId);
    if (!ra) {
      return;
    }
    const empty =
      row.value === "" ||
      row.value === null ||
      row.value === undefined ||
      (typeof row.value === "number" && Number.isNaN(row.value));
    if (empty) {
      delete byRa[ra];
    } else {
      byRa[ra] = {
        grade: row.value,
        comment: row.comment || ""
      };
    }
  });

  const root = readRoot();
  root[sessionKey] = { byRa };
  writeRoot(root);
}

export function mergePersistedDemoGrades(
  idTurmaDisc,
  idStep,
  idExam,
  students
) {
  if (!Array.isArray(students)) {
    return students;
  }
  const sessionKey = demoGradesSessionKey(idTurmaDisc, idStep, idExam);
  const snap = loadDemoGradesSession(sessionKey);
  if (!snap || !snap.byRa) {
    return students;
  }

  return students.map(s => {
    const ra = String(s.ra || s.id);
    const p = snap.byRa[ra];
    if (!p) {
      return s;
    }
    return {
      ...s,
      grade: p.grade,
      comment: p.comment
    };
  });
}

export function exportDemoGradesJson() {
  return JSON.stringify(readRoot(), null, 2);
}

export function clearDemoGradesPersistence() {
  if (typeof localStorage === "undefined") {
    return;
  }
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
